import React from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { t, translateDate } from '../common/Translate';
import MeetingTag from '../Calendar/MeetingTag';
import { DefaultAlertModal } from '../common/Modal/DefaultAlertModal';
import { REACT_APP_API } from '../../config';

const LicensePlateAlertModal = ({
  LicensePlateAlertNumber,
  usedImmatRecords,
  role,
  concessionIds,
  alertModal,
  toggleAlert,
  cancelAlert,
  fileName,
}) => {
  const modalBody = (
    <>
      <p className="modal-p">{t('popUpLicensePlateRecognized2')}</p>
      <div className="overflow-auto mt-2 mb-2">
        <table className="modal-table">
          <thead className="modal-table-thead">
            <tr>
              <td>{t('file_number')}</td>
              <td>{t('creation_date')}</td>
              <td>{t('status')}</td>
              <td>{t('pointOfSaleName')}</td>
              <td>{t('buyer')}</td>
              <td>{t('totalRefurbishmentCosts')}</td>
              <td>{t('offer')}</td>
              <td>{t('pdf')}</td>
            </tr>
          </thead>
          <tbody>
            {_.map(usedImmatRecords, (r) => (
              <tr key={r.recordId} className="modal-table-tr">
                <td className="modal-table-td">
                  {['manager', 'admin', 'superAdmin', 'multiSupervisor'].includes(role) ||
                  (['buyer', 'supervisor'].includes(role) && concessionIds.includes(r.concessionCarcheckId)) ? (
                    <Link to={`/files/${r.recordId}`} target="_blank">
                      <u>{r.refHexaId}</u>
                    </Link>
                  ) : (
                    r.refHexaId
                  )}
                </td>
                <td className="modal-table-td">{translateDate(r.createdAt.date, 'DD-MM-YYYY')}</td>
                <td className="modal-table-td">
                  <MeetingTag code={r.statusCarcheck} />
                </td>
                <td className="modal-table-td">{r.concessionName}</td>
                <td className="modal-table-td">{r.buyerFullName}</td>
                <td className="modal-table-td">{_.round(r.repairCosts)}</td>
                <td className="modal-table-td">{_.round(r.c2bOffer)}</td>
                <td className="modal-table-td">
                  {['manager', 'admin', 'superAdmin', 'multiSupervisor'].includes(role) ||
                  (['buyer', 'supervisor'].includes(role) && concessionIds.includes(r.concessionCarcheckId)) ? (
                    <a
                      target="_blank"
                      href={`${REACT_APP_API}/buyer/public/${r.sourceLabel}/${r.recordKey}/admin-documents/${r.recordId}_${fileName}.pdf`}
                      rel="noopener noreferrer"
                    >
                      <u>{t('seeReport')}</u>
                    </a>
                  ) : (
                    ''
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );

  const alertCostumProps = {
    isOpen: alertModal,
    toggle: toggleAlert,
    body: modalBody,
    handleCancel: cancelAlert,
    centered: true,
    size: 'lg',
    cancelBtn: 'close',
  };

  return (
    <>
      <Row style={{ marginTop: '15px' }}>
        <Col className="d-flex mob-display">
          <div className="p-2">
            <FontAwesomeIcon icon={faBell} size="x" color="red" />
            <span>&nbsp;&nbsp;</span>
            <span className="text-danger">
              <b>{LicensePlateAlertNumber}</b>
            </span>
            <span>&nbsp;&nbsp;</span>
            <p className="d-inline">{t('LicensePlateAlert')}</p>
          </div>
          <div>
            <button className="btn btn-block btn-3 mb-1" onClick={toggleAlert} type="button">
              <span className="d-inline-block d-sm-none d-lg-inline-block">{t('seeLicensePlatePopUp')}</span>
            </button>
          </div>
        </Col>
      </Row>
      {alertModal && <DefaultAlertModal {...alertCostumProps} />}
    </>
  );
};

LicensePlateAlertModal.propTypes = {
  LicensePlateAlertNumber: PropTypes.number.isRequired,
  usedImmatRecords: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  role: PropTypes.string.isRequired,
  concessionIds: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  alertModal: PropTypes.bool.isRequired,
  toggleAlert: PropTypes.func.isRequired,
  cancelAlert: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default LicensePlateAlertModal;
